var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnCookie = function SvgIcnCookie(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50.5 50.5",
    style: {
      enableBackground: "new 0 0 50.5 50.5"
    },
    xmlSpace: "preserve",
    fill: "#fff",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 30.4,
    cy: 18.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20,
    cy: 13.6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 39.2,
    cy: 17.7,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 38.4,
    cy: 42.5,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.3,26.8c0.3,0.3,0.8,0.4,1.3,0.4c1.1,0,2-0.9,2-2c0-1.8-0.2-3.7-0.6-5.5c-0.2-1.1-1.3-1.7-2.4-1.5 c-1.1,0.2-1.7,1.3-1.5,2.4c0.1,0.5,0.2,1,0.3,1.5c-0.6-0.1-1.2-0.2-1.9-0.2c-4,0-7.3,3-7.8,6.9c0,0,0,0-0.1,0 c-4.4,0-7.9,3.5-7.9,7.9c0,0.1,0,0.2,0,0.2c-3.4,0.9-5.9,4-5.9,7.6c0,0.7,0,1.3,0.1,1.8C12.2,45.2,3.9,36.2,3.9,25.2 c0-11.7,9.6-21.3,21.3-21.3c6.9,0,13.3,3.3,17.3,8.9c0.6,0.9,1.9,1.1,2.8,0.5c0.9-0.6,1.1-1.9,0.5-2.8c-2.3-3.2-5.3-5.9-8.8-7.7 C33.4,1,29.3,0,25.2,0C18.5,0,12.2,2.6,7.4,7.4C2.6,12.2,0,18.5,0,25.2s2.6,13.1,7.4,17.9c4.8,4.8,11.1,7.4,17.9,7.4c0,0,0,0,0,0 c0.1,0,0.1,0,0.2,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0 c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0.1-0.1c0,0,0,0,0,0 c0,0,0,0,0.1,0c0,0,0,0,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1 c0,0,0,0,0,0c0-0.1,0.1-0.1,0.1-0.2c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1 c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.2 c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1 c-0.1-0.2-0.3-0.9-0.3-2.9c0-2.2,1.8-3.9,3.9-3.9c0.1,0,0.1,0,0.2,0c0.7,0,1.3-0.3,1.7-0.8s0.5-1.2,0.3-1.8 c-0.2-0.4-0.2-0.9-0.2-1.3c0-2.2,1.8-3.9,3.9-3.9c0.5,0,1,0.1,1.4,0.3c0.7,0.3,1.5,0.1,2-0.4c0.6-0.5,0.8-1.2,0.6-1.9 c-0.1-0.3-0.1-0.6-0.1-0.9c0-2.2,1.8-3.9,3.9-3.9C46.1,25.8,47.3,26.8,47.3,26.8L47.3,26.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11.1,
    cy: 25.6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 48.3,
    cy: 48.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 48.3,
    cy: 39.8,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16.8,
    cy: 34.3,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20.8,
    cy: 27.7,
    r: 2
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnCookie, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_cookie.0b0a7d15.svg";
export { ForwardRef as ReactComponent };